import React from 'react'
import Email from './subcomponents/Email'
import Phone from 'modules/User/Profile/subcomponents/Phone'
import { useTranslation } from 'react-i18next'
import { Typography } from 'gu-ui-kit'

const Profile = () => {
  const { t } = useTranslation()

  return (
    <>
      <Typography component={'h3'} variant={'Subtitle-25'} className={'margin-bottom-16'}>
        {t('user::settings.profile.auth_fields')}
      </Typography>

      <div className={'margin-bottom-16'}>
        <Email />
      </div>
      <div>
        <Phone />
      </div>
    </>
  )
}

export default Profile
